import { theme } from '@chakra-ui/react';

export const text = {
	variants: {
		primary: {
			fontSize: '0.75rem',
			fontWeight: '700',
			color: theme.colors.white,
		},
		secondary: {
			fontSize: '0.625rem',
		},
	},
};
